function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useAppContext } from "../components/CEF/Providers";
import { getAcceptableCountries } from "../components/StudentOnboarding/storage/Countries/localStorage";
import { getStoredFieldsOfEducation } from "../components/StudentOnboarding/storage/FieldsOfEducation/localStorage";
import { getStoredIntakes } from "../components/StudentOnboarding/storage/Intakes/localStorage";
import { getStoredProgramLevelFamily } from "../components/StudentOnboarding/storage/ProgramLevelFamilies/localStorage";
import { useFieldsOfEducation } from "../data/fieldsOfEducation";
import { useMarketPreferences } from "../data/marketPreferences";
import { useStudentPreferences } from "../data/studentPreferences";
import { useFieldsOfStudyParamMapping } from "./useFieldsOfStudyParamMapping";
import { EligibilityAnswers } from "../models/Eligibility";
import { useRPSearchParams } from "../models/RPSearchParams";
import { useDsjState } from "./useDsjState";
export function useSearchParams() {
  var _userIdNum$toString;
  var _useAppContext = useAppContext(),
    userIdNum = _useAppContext.userId;
  var state = useDsjState();
  var userId = (_userIdNum$toString = userIdNum === null || userIdNum === void 0 ? void 0 : userIdNum.toString()) !== null && _userIdNum$toString !== void 0 ? _userIdNum$toString : null;
  var _useStudentPreference = useStudentPreferences(userId, {
      enabled: Boolean(userId)
    }),
    studentPreferences = _useStudentPreference.studentPreferences,
    isLoadingStudentPreferences = _useStudentPreference.isLoadingStudentPreferences;
  var _useMarketPreferences = useMarketPreferences(userId, {
      enabled: Boolean(userId)
    }),
    marketPreferences = _useMarketPreferences.marketPreferences,
    isLoadingMarketPreferences = _useMarketPreferences.isLoadingMarketPreferences;
  var _useFieldsOfEducation = useFieldsOfEducation(),
    fieldsOfEducationData = _useFieldsOfEducation.fieldsOfEducationData,
    isLoadingFieldsOfEducationData = _useFieldsOfEducation.isLoadingFieldsOfEducationData;
  var fieldsOfEducationRaw = userId ? studentPreferences.fieldOfEducation : getStoredFieldsOfEducation();
  var fieldsOfEducation = useFieldsOfStudyParamMapping(fieldsOfEducationRaw, fieldsOfEducationData);
  var _useRPSearchParams = useRPSearchParams(),
    convertAnswersToSearchParams = _useRPSearchParams.convertAnswersToSearchParams;
  if (isLoadingStudentPreferences || isLoadingMarketPreferences || isLoadingFieldsOfEducationData) {
    return null;
  }
  var eligibilityAnswers = EligibilityAnswers.fromDsjState(state.CefApplication ? state : null);
  var params = convertAnswersToSearchParams(_objectSpread({
    countries: userId ? marketPreferences : getAcceptableCountries(),
    fieldsOfEducation: fieldsOfEducation,
    programLevelFamilies: userId ? studentPreferences.programLevelFamily : getStoredProgramLevelFamily(),
    intakes: userId ? studentPreferences.intakes : getStoredIntakes()
  }, eligibilityAnswers));
  return params;
}